// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FireOutlinedSvg from "@fishx/icons-svg/es/asn/FireOutlined";
import FishxIcon from '../components/FishxIcon';

var FireOutlined = function FireOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FireOutlinedSvg
  }));
};

FireOutlined.displayName = 'FireOutlined';
export default React.forwardRef(FireOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FireOutlined.js
// module id = 2782
// module chunks = 0